import { render, staticRenderFns } from "./LibFooter.vue?vue&type=template&id=cd8c9992&scoped=true"
import script from "./LibFooter.vue?vue&type=script&lang=js"
export * from "./LibFooter.vue?vue&type=script&lang=js"
import style0 from "./LibFooter.vue?vue&type=style&index=0&id=cd8c9992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8c9992",
  null
  
)

export default component.exports